module.exports = __webpack_public_path__ + "img/rad-dig-sala-config-3.30c80708.png";